// src/App.js
import React, { useState } from 'react';
import './App.css';
import app from './firebase';
import Login from './Login';
import UploadWallpaper from './UploadWallpaper';
import DraftWallpapers from './DraftWallpapers';
import WallpaperDoneList from './WallpaperDoneList';
import HomepageAlbums from './HomepageAlbums';
import AlbumOrderManager from './components/AlbumOrderManager';
// 👇 OVO JE JEDINA PROMENA — putanja sada tačno prati ime fajla na disku
import WallpaperStats from './wallpaperStats';
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Navigate,
} from "react-router-dom";

function App() {
  const [user, setUser] = useState(null);
  const [error, setError] = useState('');
  const [refreshDrafts, setRefreshDrafts] = useState(0);

  const handleLogin = (email, password) => {
    setError('');
    const auth = getAuth(app);
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        setUser(userCredential.user);
      })
      .catch((error) => {
        setError(error.message);
      });
  };

  const handleLogout = () => {
    const auth = getAuth(app);
    signOut(auth).then(() => setUser(null));
  };

  const triggerDraftRefresh = () => {
    setRefreshDrafts(prev => prev + 1);
  };

  if (!user) {
    return (
      <div>
        <Login onLogin={handleLogin} />
        {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        <h1>Firebase React Admin Panel</h1>
        <p>Welcome, {user.email}!</p>
        <button onClick={handleLogout}>Logout</button>

        <nav style={{ marginBottom: 20 }}>
          <Link to="/">Upload Wallpapers</Link> |{" "}
          <Link to="/done">Done Wallpapers</Link> |{" "}
          <Link to="/homepage-albums">Homepage Albums</Link> |{" "}
          <Link to="/order-abstract">Order Abstract</Link> |{" "}
          <Link to="/order-animals">Order Animals</Link> |{" "}
          <Link to="/order-artistic">Order Artistic</Link> |{" "}
          <Link to="/order-black-and-white">Order Black and White</Link> |{" "}
          <Link to="/order-cars">Order Cars</Link> |{" "}
          <Link to="/order-cartoons">Order Cartoons</Link> |{" "}
          <Link to="/order-chaos">Order Chaos</Link> |{" "}
          <Link to="/order-colorful">Order Colorful</Link> |{" "}
          <Link to="/order-comics">Order Comics</Link> |{" "}
          <Link to="/order-frightful-comics">Order Frightful Comics</Link> |{" "}
          <Link to="/order-game-zone">Order Game Zone</Link> |{" "}
          <Link to="/order-graffiti">Order Graffiti</Link> |{" "}
          <Link to="/order-grunge-posters">Order Grunge Posters</Link> |{" "}
          <Link to="/order-halloween">Order Halloween</Link> |{" "}
          <Link to="/order-holidays">Order Holidays</Link> |{" "}
          <Link to="/order-love">Order Love</Link> |{" "}
          <Link to="/order-music">Order Music</Link> |{" "}
          <Link to="/order-nature">Order Nature</Link> |{" "}
          <Link to="/order-neon-art">Order Neon Art</Link> |{" "}
          <Link to="/order-popastic">Order Popastic</Link> |{" "}
          <Link to="/order-popular">Order Popular</Link> |{" "}
          <Link to="/order-psychedelic">Order Psychedelic</Link> |{" "}
          <Link to="/order-sayings">Order Sayings</Link> |{" "}
          <Link to="/order-skulls">Order Skulls</Link> |{" "}
          <Link to="/order-space">Order Space</Link> |{" "}
          <Link to="/order-sport">Order Sport</Link> |{" "}
          <Link to="/order-summer">Order Summer</Link> |{" "}
          <Link to="/order-surreal">Order Surreal</Link> |{" "}
          <Link to="/order-synthwave">Order Synthwave</Link> |{" "}
          <Link to="/order-trending">Order Trending</Link> |{" "}
          <Link to="/order-vibes">Order Vibes</Link> |{" "}
          <Link to="/order-winter">Order Winter</Link> |{" "}
          <Link to="/order-editors-pick">Order Editor's Pick</Link> |{" "}
          <Link to="/order-editorspick">Order Editors Pick</Link> |{" "}
          <Link to="/order-floral">Order Floral</Link> |{" "}
          <Link to="/order-good-night">Order Good Night</Link> |{" "}
          <Link to="/order-new-year">Order New Year</Link> |{" "}
          <Link to="/order-retro">Order Retro</Link> |{" "}
          <Link to="/order-amoled">Order AMOLED</Link> |{" "}
          <Link to="/order-dark-mode">Order Dark Mode</Link> |{" "}
          <Link to="/order-dreamlike">Order Dreamlike</Link> |{" "}
          <Link to="/order-money">Order Money</Link> |{" "}
          <Link to="/order-whimsical">Order Whimsical</Link> |{" "}
          <Link to="/order-for-kids">Order For Kids</Link> |{" "}
          <Link to="/order-cats">Order Cats</Link> |{" "}
          <Link to="/order-dogs">Order Dogs</Link> |{" "}
          <Link to="/order-industrial">Order Industrial</Link> |{" "}
          <Link to="/order-neon-frames">Order Neon Frames</Link> |{" "}
          <Link to="/order-spring">Order Spring</Link> |{" "}
          <Link to="/order-easter">Order Easter</Link> |{" "}
          <Link to="/order-autumn">Order Autumn</Link> |{" "}
          <Link to="/order-christmas">Order Christmas</Link> |{" "}
          <Link to="/order-lock-screen">Order Lock Screen</Link> |{" "}
          <Link to="/order-aesthetic">Order Aesthetic</Link> |{" "}
          <Link to="/order-cyberpunk">Order Cyberpunk</Link> |{" "}
          <Link to="/order-minimal">Order Minimal</Link> |{" "}
          <Link to="/order-twin-pinks">Order Twin Pinks</Link> |{" "}
          <Link to="/stats">Wallpaper Stats</Link> {/* ✅ NOVO */}
        </nav>

        <Routes>
          <Route
            path="/"
            element={
              <>
                <UploadWallpaper onUploadSuccess={triggerDraftRefresh} />
                <DraftWallpapers refreshKey={refreshDrafts} />
              </>
            }
          />
          <Route path="/done" element={<WallpaperDoneList />} />
          <Route path="/homepage-albums" element={<HomepageAlbums />} />

          {/* ✅ Reorder stranice za sve albume */}
          <Route path="/order-abstract" element={<AlbumOrderManager albumName="ABSTRACT" />} />
          <Route path="/order-animals" element={<AlbumOrderManager albumName="ANIMALS" />} />
          <Route path="/order-artistic" element={<AlbumOrderManager albumName="ARTISTIC" />} />
          <Route path="/order-black-and-white" element={<AlbumOrderManager albumName="BLACK AND WHITE" />} />
          <Route path="/order-cars" element={<AlbumOrderManager albumName="CARS" />} />
          <Route path="/order-cartoons" element={<AlbumOrderManager albumName="CARTOONS" />} />
          <Route path="/order-chaos" element={<AlbumOrderManager albumName="CHAOS" />} />
          <Route path="/order-colorful" element={<AlbumOrderManager albumName="COLORFUL" />} />
          <Route path="/order-comics" element={<AlbumOrderManager albumName="COMICS" />} />
          <Route path="/order-frightful-comics" element={<AlbumOrderManager albumName="FRIGHTFUL COMICS" />} />
          <Route path="/order-game-zone" element={<AlbumOrderManager albumName="GAME ZONE" />} />
          <Route path="/order-graffiti" element={<AlbumOrderManager albumName="GRAFFITI" />} />
          <Route path="/order-grunge-posters" element={<AlbumOrderManager albumName="GRUNGE POSTERS" />} />
          <Route path="/order-halloween" element={<AlbumOrderManager albumName="HALLOWEEN" />} />
          <Route path="/order-holidays" element={<AlbumOrderManager albumName="HOLIDAYS" />} />
          <Route path="/order-love" element={<AlbumOrderManager albumName="LOVE" />} />
          <Route path="/order-music" element={<AlbumOrderManager albumName="MUSIC" />} />
          <Route path="/order-nature" element={<AlbumOrderManager albumName="NATURE" />} />
          <Route path="/order-neon-art" element={<AlbumOrderManager albumName="NEON ART" />} />
          <Route path="/order-popastic" element={<AlbumOrderManager albumName="POPASTIC" />} />
          <Route path="/order-popular" element={<AlbumOrderManager albumName="POPULAR" />} />
          <Route path="/order-psychedelic" element={<AlbumOrderManager albumName="PSYCHEDELIC" />} />
          <Route path="/order-sayings" element={<AlbumOrderManager albumName="SAYINGS" />} />
          <Route path="/order-skulls" element={<AlbumOrderManager albumName="SKULLS" />} />
          <Route path="/order-space" element={<AlbumOrderManager albumName="SPACE" />} />
          <Route path="/order-sport" element={<AlbumOrderManager albumName="SPORT" />} />
          <Route path="/order-summer" element={<AlbumOrderManager albumName="SUMMER" />} />
          <Route path="/order-surreal" element={<AlbumOrderManager albumName="SURREAL" />} />
          <Route path="/order-synthwave" element={<AlbumOrderManager albumName="SYNTHWAVE" />} />
          <Route path="/order-trending" element={<AlbumOrderManager albumName="TRENDING" />} />
          <Route path="/order-vibes" element={<AlbumOrderManager albumName="VIBES" />} />
          <Route path="/order-winter" element={<AlbumOrderManager albumName="WINTER" />} />
          <Route path="/order-editors-pick" element={<AlbumOrderManager albumName="EDITOR'S PICK" />} />
          <Route path="/order-editorspick" element={<AlbumOrderManager albumName="EDITORS PICK" />} />
          <Route path="/order-floral" element={<AlbumOrderManager albumName="FLORAL" />} />
          <Route path="/order-good-night" element={<AlbumOrderManager albumName="GOOD NIGHT" />} />
          <Route path="/order-new-year" element={<AlbumOrderManager albumName="NEW YEAR" />} />
          <Route path="/order-retro" element={<AlbumOrderManager albumName="RETRO" />} />
          <Route path="/order-amoled" element={<AlbumOrderManager albumName="AMOLED" />} />
          <Route path="/order-dark-mode" element={<AlbumOrderManager albumName="DARK MODE" />} />
          <Route path="/order-dreamlike" element={<AlbumOrderManager albumName="DREAMLIKE" />} />
          <Route path="/order-money" element={<AlbumOrderManager albumName="MONEY" />} />
          <Route path="/order-whimsical" element={<AlbumOrderManager albumName="WHIMSICAL" />} />
          <Route path="/order-for-kids" element={<AlbumOrderManager albumName="FOR KIDS" />} />
          <Route path="/order-cats" element={<AlbumOrderManager albumName="CATS" />} />
          <Route path="/order-dogs" element={<AlbumOrderManager albumName="DOGS" />} />
          <Route path="/order-industrial" element={<AlbumOrderManager albumName="INDUSTRIAL" />} />
          <Route path="/order-neon-frames" element={<AlbumOrderManager albumName="NEON FRAMES" />} />
          <Route path="/order-spring" element={<AlbumOrderManager albumName="SPRING" />} />
          <Route path="/order-easter" element={<AlbumOrderManager albumName="EASTER" />} />
          <Route path="/order-autumn" element={<AlbumOrderManager albumName="AUTUMN" />} />
          <Route path="/order-christmas" element={<AlbumOrderManager albumName="CHRISTMAS" />} />
          <Route path="/order-lock-screen" element={<AlbumOrderManager albumName="LOCK SCREEN" />} />
          <Route path="/order-aesthetic" element={<AlbumOrderManager albumName="AESTHETIC" />} />
          <Route path="/order-cyberpunk" element={<AlbumOrderManager albumName="CYBERPUNK" />} />
          <Route path="/order-minimal" element={<AlbumOrderManager albumName="MINIMAL" />} />
          <Route path="/order-twin-pinks" element={<AlbumOrderManager albumName="TWIN PINKS" />} />

          {/* ✅ stats ruta */}
          <Route path="/stats" element={<WallpaperStats />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
